import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const TabBadge = styled(Box)<{ color: string; background: string }>`
  ${({ theme, color, background }) => css`
    position: relative;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    width: fit-content;
    margin-bottom: -1px;
    padding: 8px 14px;
    border: 1px dashed ${theme.colors.border.light};
    border-bottom: none;
    border-radius: 10px 10px 0 0;
    font-size: 14px;
    font-weight: 600;
    color: ${color};
    background: ${background};
  `}
`

export const Dot = styled(Box)<{ color: string }>`
  ${({ color }) => css`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${color};
  `}
`

export const StatusCountBadge = styled(Box)<{ color: string }>`
  ${({ theme, color }) => css`
    font-size: 12px;
    font-weight: 700;
    padding: 1px 8px;
    border-radius: 6px;
    color: ${color};
    background: ${theme.colors.lightest};
  `}
`

export const DashedCard = styled(Box)`
  ${({ theme }) => css`
    padding: 16px;
    border: 1px dashed ${theme.colors.border.light};
    border-radius: 0 12px 12px 12px;
  `}
`

export const Card = styled(Box)`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.border.light};
    border-radius: 12px;
    background: ${theme.colors.lightest};
    box-shadow: 4px 4px 8px 0 ${theme.colors.background.hover};
    overflow: hidden;
  `}
`

export const CardHeader = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px 20px;
    font-size: 16px;
    font-weight: 600;
    color: ${theme.colors.secondary};
  `}
`

export const IconWrapper = styled(Box)<{ color: string }>`
  ${({ color }) => css`
    display: flex;
    align-items: center;
    color: ${color};
  `}
`

export const UnitList = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 20px 20px;
`

export const UnitRow = styled(Box)`
  ${({ theme }) => css`
    padding: 14px 16px;
    border: 1px solid ${theme.colors.border.light};
    border-radius: 24px;
    font-size: 14px;
    font-weight: 600;
    color: ${theme.colors.secondary};
    background: ${theme.colors.gray[100]};
  `}
`

export const Footer = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    justify-content: flex-end;
    padding: 16px 20px;
    border-top: 1px solid ${theme.colors.border.light};
  `}
`
